module.exports = __webpack_public_path__ + "img/229.6b0273fb.jpg";